<button mat-icon-button class="disabledWhite" *ngIf="!isFromActionList" [disabled]="selectionModel.selected.length === 0 || selectionModel.selected.length > 50" (click)="addFavorite()">
  <mat-icon>star_border</mat-icon>
</button>

<button mat-menu-item class="disabledWhite" *ngIf="isFromActionList" [class.fromActionList]="isFromActionList" [disabled]="selectionModel.selected.length === 0 || selectionModel.selected.length > 50" (click)="addFavorite()">
  <mat-icon>star_border</mat-icon>
  <span>Ajouter en favoris</span>
</button>
